<template>
  <div>
    <v-card outlined elevation="0" class="rounded-lg ma-4" tile>
      <v-sheet :class="showReferralCodes ? '' : 'rounded-lg'" color="primary">
        <v-card-title class="py-2 card-title-height">
          <v-btn icon @click="card()">
            <v-icon color="white">
              {{
                showReferralCodes ? "mdi-chevron-up" : "mdi-chevron-down"
              }}
            </v-icon>
          </v-btn>
          <span class="text-body-1 white--text" white--text>Codes</span>
          <v-spacer />
          <v-btn elevation="0" icon @click="addCode()">
            <v-icon color="white" class="pr-1">mdi-plus-thick</v-icon>
          </v-btn>
        </v-card-title>
      </v-sheet>
      <v-expand-transition>
        <div v-show="showReferralCodes" class="grey lighten-4">
          <v-divider />
          <div class="">
            <v-data-table
              :headers="headers"
              fixed-header
              height="300"
              :items="customer.referralCodes"
              :options.sync="options"
              loading-text="Loading... Please wait"
              class="elevation-1"
            >
              <template #item.used="{ item }">
                {{ item.used ? 'Oui' : 'Non' }}
              </template>
            </v-data-table>
          </div>
        </div>
      </v-expand-transition>
    </v-card>

    <AddReferralCode :customer="customer" />
  </div>
</template>

<script>

import { EventBus } from '../../mixins';
import { requests } from '@/mixins';
import AddReferralCode from '@/components/profile/AddReferralCode';

export default {
  components: { AddReferralCode },
  mixins: [requests],
  props: { customer: Object },
  data () {
    return {
      options: { itemsPerPage: 5 },
      headers: [
        { text: 'Code', value: 'id', sortable: false },
        { text: 'Type', value: 'type', sortable: true },
        { text: 'Utilisé', value: 'used', sortable: true },
        { text: 'Expiration', value: 'expires_at', sortable: true },
        { text: 'Order', value: 'order', sortable: false }
      ],
      showReferralCodes: true
    };
  },
  methods: {
    addCode () {
      EventBus.$emit('startAddCode');
    },
    card () {
      this.showReferralCodes = !this.showReferralCodes;
    }
  }
};
</script>

<style lang="scss">
.card-title-height {
  height: 56px;
}

</style>
